var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 231,
    viewBox: "0 0 372 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.096 34.3105C181.387 12.6734 136.248 -14.2728 109.055 9.80823C99.1466 18.5832 101.296 48.3773 77.4575 63.0736C19.2342 98.9678 89.1203 131.804 96.5192 132.152C110.762 132.822 32.3614 148.426 16.8222 160.681C-11.2346 182.808 -1.91511 204.639 31.6031 219.92C96.9544 249.713 145.511 212.725 181.829 137.658C205.189 89.3736 273.838 152.901 324.509 145.933C348.673 142.61 367.681 109.708 371.26 87.9158C379.225 39.4184 269.279 52.4619 251.811 75.227C238.954 91.9838 199.636 86.0394 189.096 34.3105V34.3105Z",
    fill: "url(#paint0_radial_2_35)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.672 8.07073C116.872 6.87073 111.506 21.2374 110.672 28.5707C109.072 46.9707 94.0056 63.2374 86.6723 69.0707C64.6723 79.0707 64.5056 94.9041 67.1723 101.571C86.3723 117.971 110.839 112.404 120.672 107.571C135.072 106.771 153.006 78.5707 160.172 64.5707C172.172 39.7707 165.172 22.9041 160.172 17.5707C158.172 11.9707 140.339 8.90406 131.672 8.07073Z",
    fill: "#7DBC52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.431 16.5854C121.009 16.9034 118.657 26.3032 118.659 30.9634C118.973 42.6208 110.639 53.9142 106.433 58.1037C93.275 65.9679 94.3088 75.9116 96.4705 79.9004C109.762 88.7985 124.795 83.5368 130.65 79.7937C139.676 78.2502 148.96 59.2641 152.473 49.964C158.259 33.5398 152.63 23.4664 149.092 20.4827C147.428 17.1147 135.958 16.4812 130.431 16.5854Z",
    fill: "#97CD67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.5 111C121.7 117 92.5 118.167 79 118C86.6 126.4 108.833 134.167 119 137C156.399 144.957 169.856 122.245 177.871 108.717L178 108.5C186 90 182.833 43.8333 174 21C178 67.4 146.667 100.333 130.5 111Z",
    fill: "#6BAD5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.274 21.1094C134.786 21.8267 135.833 25.8805 134.612 30.1562C133.391 34.4318 130.36 37.3208 127.848 36.6033C125.336 35.8858 124.289 31.8322 125.51 27.5563C126.731 23.2806 129.762 20.3918 132.274 21.1094Z",
    fill: "#E7F3C4",
    fillOpacity: 0.39
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_35",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.222 50.7092) rotate(42.292) scale(168.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#388940"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBlob);
export default __webpack_public_path__ + "static/media/green-blob.52a5a9e12ba7958970cc318239088a4d.svg";
export { ForwardRef as ReactComponent };